import { translationBaseKey } from '../decorators/translation-base-key.decorator';
import {advancedFormControl, FormControlTypeEnum} from "@magieno/common";

@translationBaseKey('')
export class CreateCorporateClientOptions {
  @advancedFormControl({
    type: FormControlTypeEnum.Input
  })
  companyName: string;
}